var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgToDoListIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.13 12.01h4.178M11.13 16.002l6.002.005"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.008,
    height: 18.008,
    x: 3.001,
    y: 3.001,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.13 7.998h6.002M7.127 7.753a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5M7.127 11.755a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5M7.127 15.757a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgToDoListIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ToDoListIcon.05ce4fea.svg";
export { ForwardRef as ReactComponent };